import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, getWeek, getYear } from 'date-fns';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDateKey = (date = new Date()) => {
  return format(date, 'yyyy-MM-dd');
};

export const formatWeekNumber = (date = new Date()) => {
  const year = getYear(date);
  const week = getWeek(date, { weekStartsOn: 1 });
  return `${year}-W${week.toString().padStart(2, '0')}`;
};

export const getCurrentWeekLabel = () => {
  const weekNum = formatWeekNumber();
  return weekNum;
};

export const getEnergyColor = (level) => {
  if (level >= 4) return 'bg-lime-100 text-lime-800 border-lime-200';
  if (level === 3) return 'bg-amber-100 text-amber-800 border-amber-200';
  return 'bg-rose-100 text-rose-800 border-rose-200';
};

export const getEnergyBgColor = (level) => {
  if (level >= 4) return 'bg-lime-500';
  if (level === 3) return 'bg-amber-500';
  return 'bg-rose-500';
};

export const getStressColor = (level) => {
  // For stress, lower is better (inverse of energy)
  if (level <= 2) return 'bg-lime-100 text-lime-800 border-lime-200';
  if (level === 3) return 'bg-amber-100 text-amber-800 border-amber-200';
  return 'bg-rose-100 text-rose-800 border-rose-200';
};

export const getEmotionalStateColor = (state) => {
  const colors = {
    Focused: 'bg-sky-100 text-sky-800 border-sky-200',
    Motivated: 'bg-lime-100 text-lime-800 border-lime-200',
    Neutral: 'bg-stone-100 text-stone-800 border-stone-200',
    Overwhelmed: 'bg-amber-100 text-amber-800 border-amber-200',
    Drained: 'bg-rose-100 text-rose-800 border-rose-200'
  };
  return colors[state] || 'bg-stone-100 text-stone-800';
};

export const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
